import React from 'react';
import style from '../css/Prior.module.css';
import {
	FaCarRear,
	FaGooglePlus,
	FaRegStar,
	FaRegStarHalf,
	FaSuitcaseRolling,
} from 'react-icons/fa6';
import image from '../assets/images/IMG-20250826-WA0041.jpg';
import { Link } from 'react-router-dom';

function Prior() {
	const card = [
		{
			id: 1,
			title: 'Create company travel program',
			icon: <FaCarRear className={style.icon} />,
		},
		{
			id: 2,
			title: 'Book trips for emplayees & execs',
			icon: <FaSuitcaseRolling className={style.icon} />,
		},
	];

	const card_one = [
		{
			id: 1,
			title: 'Book my own trip',
		},
		{
			id: 2,
			title: 'Manage travel & expenses',
		},
		{
			id: 3,
			title: 'Arrange a team offsite',
		},
	];

	return (
		<div className={style.prior}>
			<div className={style.component}>
				<div className={style.iconContainer}>
					<FaGooglePlus className={style.iconTop} />
					<FaRegStar className={style.iconStar} />
					<FaRegStar className={style.iconStar} />
					<FaRegStar className={style.iconStar} />
					<FaRegStar className={style.iconStar} />
					<FaRegStarHalf className={style.iconStar} />
					<p className={style.textColor}>4.7 out of 5 | 7K+ reviews</p>
				</div>
				<h1 className={style.corp}>Streamlining Business Travel, Everywhere</h1>
				<h4 className={style.text}>What would you like to do with Exporest?</h4>
				<div>
					<div className={style.cardContainer}>
						{card.map((item) => (
							<div key={item.id} className={style.card}>
								{item.icon}
								<p>{item.title}</p>
							</div>
						))}
					</div>

					<div className={style.cardContainer}>
						{card_one.map((item) => (
							<div key={item.id} className={style.card_one}>
								{item.icon}
								<p>{item.title}</p>
							</div>
						))}
					</div>
				</div>

				<Link className={style.btnRegi}>Get Started</Link>
			</div>
			<img src={image} alt="Exporest" className={style.image} />
		</div>
	);
}

export default Prior;
